module.exports = __webpack_public_path__ + "media/images/pages/get-involved/impact_background-be747b8445949fa990f61c01eccb0af6.png";